module.exports = __webpack_public_path__ + "img/img2.54cc2002.jpg";